<template>
    <div class="overlay">
        <div class="overlay__message">
            {{ params.message ?? "No results found." }}
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class NoRowsOverlayComponent extends Vue {}
</script>

<style scoped lang="scss">
@import 'src/globals';

.overlay {
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__message {
        color: $warm-grey;
        font-size: 14px;
        text-align: center;
        margin-top: 4px;
    }
}
</style>
